import React, { useState, useCallback } from 'react'
import classnames from 'classnames/bind'
import { Link as ReactLink } from 'react-scroll'
import { navigate, Link as GatsbyLink } from "gatsby"
import { useLocation } from "@reach/router"

// Components
import Button from '@/components/common/Button'
import LanguageDropdown from '@/components/common/Dropdown'
import Logo from '@/assets/images/recard-logo@2x.png'
import MenuIcon from '@/assets/svg/header-menu.svg'
import CloseIcon from '@/assets/svg/header-close.svg'
import langIcon from '@/assets/images/btn-nav-language.png'
import arrowIcon from '@/assets/images/btn-menu-arrow-down.png'

// Lib MISC
import { useHeaderScroll } from '@/computedValues/useHeaderScroll'
import styles from './style.scss'
import words from "@/assets/worddict.json"

const cx = classnames.bind(styles)

const langList = [
  { name: 'English', key: 'en' },
  { name: '繁體中文', key: 'zh' }
]

export const propTypes = {}


function Header ({ lang }) {
  const $t = words[lang]
  const location = useLocation();

  const [isMenuOpened, setIsMenuOpened] = useState(false)
  const [isLangOpened, setIsLangOpened] = useState(false)

  const selectedLang = langList.find(item => item.key === lang)
    ? langList.find(item => item.key === lang)
    : langList[0]

  const { scrollY } = useHeaderScroll()

  const isTop = scrollY === 0

  const onMenuItemClick = () => setIsMenuOpened(false)

  const onCreateCardsClick = () => {
    window.location.href = 'https://create.re.cards/?page=step1'
  }


  const handleLangChange = ({ key }) => {
    if (key !== lang) {
      navigate(location.pathname.replace(lang, key))
    }
    setIsLangOpened(false)
  }

  const Link = useCallback(({ className, to, spy, smooth, offset, children }) => {
    const hasPath = Boolean(location.pathname.replace(`/${lang}`, ''))
    return (
      <div className={className}>
        {
          hasPath ?
            <GatsbyLink to={`/${lang}`} >
              {children}
            </GatsbyLink >
            :
            <ReactLink to={to} spy={spy} smooth={smooth} offset={offset}>
              {children}
            </ReactLink>
        }
      </div>
    )
  }, [location])

  return (
    <div className={cx('header')} data-no-shadow={isTop} data-is-opened={isMenuOpened}>
      <div className={cx('header-wrapper')} data-is-opened={isMenuOpened}>
        <div className={cx('header-wrapper__logo')}>
          <Link lang={lang} to='landing' spy={true} smooth={true} offset={-88}>
            <img className={cx('header-wrapper__logo-image')} src={Logo} />
          </Link>
          {/* tablet 的位置跟 mobile 不一樣，所以 tablet 直接給另一個 element */}
          <div className={cx('header-wrapper__logo-button', 'tablet')}>
            <Button className={cx('header-wrapper__logo-button-item')} onClick={onCreateCardsClick}>
              {$t.TXT_Header_create_your_cards_button}
            </Button>
          </div>
          {!isMenuOpened && <img className={cx('header-wrapper__logo-icon')} src={MenuIcon} onClick={() => setIsMenuOpened(true)} />}
          {isMenuOpened && <img className={cx('header-wrapper__logo-icon')} src={CloseIcon} onClick={() => setIsMenuOpened(false)} />}
        </div>

        <div className={cx('header-wrapper__action')} data-is-opened={isMenuOpened}>
          <div className={cx('header-wrapper__action-list')}>
            <Link lang={lang} className={cx('header-wrapper__action-list-link')} to='feature' spy={true} smooth={true}>
              <p className={cx('header-wrapper__action-list-link-text')} onClick={onMenuItemClick}>
                {$t.TXT_Header_features}
              </p>
            </Link>
            <Link lang={lang} className={cx('header-wrapper__action-list-link')} to='solution' spy={true} smooth={true}>
              <p className={cx('header-wrapper__action-list-link-text')} onClick={onMenuItemClick}>
                {$t.TXT_Header_solution}
              </p>
            </Link>
            <Link lang={lang} className={cx('header-wrapper__action-list-link')} to='contact' spy={true} smooth={true}>
              <p className={cx('header-wrapper__action-list-link-text')} onClick={onMenuItemClick}>
                {$t.TXT_Header_contact}
              </p>
            </Link>
            <div className={cx('header-wrapper__action-list-language')} onClick={() => setIsLangOpened(!isLangOpened)}>
              <img className={cx('header-wrapper__action-list-language-icon')} src={langIcon} />
              <p className={cx('header-wrapper__action-list-language-title')}>{$t.TXT_Header_language}</p>
              <p className={cx('header-wrapper__action-list-language-selected')}>{selectedLang.name}</p>
              <img className={cx('header-wrapper__action-list-language-icon')} src={arrowIcon} />
            </div>
            {isLangOpened && <div className={cx('header-wrapper__action-list-language-list')}>
              {
                langList.map(items =>
                  <div
                    className={cx('header-wrapper__action-list-language-list-items')}
                    key={items.key}
                    onClick={() => handleLangChange(items)}
                  >
                    {items.name}
                  </div>
                )
              }
            </div>}
          </div>
          {/* only desktop and mobile */}
          <div className={cx('header-wrapper__action-button')}>
            <Button className={cx('header-wrapper__action-button-item')} onClick={onCreateCardsClick}>
              {$t.TXT_Header_create_your_cards_button}
            </Button>

            <LanguageDropdown
              className={cx('header-wrapper__action-button-item', 'header-wrapper__action-dropdown')}
              type='light'
              headIcon={langIcon}
              list={langList}
              handleSelect={handleLangChange}
              value={selectedLang.name}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

Header.propTypes = propTypes

export default Header
